import styled from 'styled-components';
import ds from 'designsystem';

const DesktopNavButton = styled.a`
  cursor: pointer;
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  color: ${ds.brand('text')};
  padding: 0 ${ds.get('metrics.s')};
  font-weight: ${({ active }) => (active ? ds.get('type.fontWeight.bold') : ds.get('type.fontWeight.regular'))};

  &:after {
    content: '';
    display: block;
    top: calc(${ds.get('metrics.m')} + ${ds.get('metrics.s')} / 2);
    width: ${({ active }) => (active ? ds.get('metrics.base') : 0)};
    height: 4px;
    position: absolute;
    background-color: ${ds.brand('secondary')};
    transition-duration: 0.25s;
  }
`;

export default DesktopNavButton;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/DesktopNavigation/DesktopNavButton.jsx